exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media print{modal-calendar-grid .modal{background:#fff!important;position:relative}}modal-calendar-grid calendar{pointer-events:none!important}modal-calendar-grid .modal-dialog{width:914px}@media print{modal-calendar-grid .modal-dialog{border:0!important;overflow:hidden;margin:0;width:100%}}modal-calendar-grid .modal-dialog .modal-content{padding:50px 85px;border-radius:4px!important}@media print{modal-calendar-grid .modal-dialog .modal-content{box-shadow:none!important;border:0!important;padding:0 20px!important}}modal-calendar-grid .modal-dialog .modal-header{border:none;padding-bottom:20px}@media print{modal-calendar-grid .modal-dialog .modal-header{padding-bottom:0!important}modal-calendar-grid .modal-dialog .modal-header h4{padding-bottom:0;font-size:20px}}@media print{modal-calendar-grid .modal-dialog .modal-footer{display:none!important}}modal-calendar-grid .modal-dialog .modal-footer .btn{height:37px;line-height:37px;width:150px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/components/modals/modalCalendarGrid/modalCalendarGrid.scss
// module id = 1414
// module chunks = 0